import 'unfonts.css';
import { RouterProvider } from 'react-router-dom';
import '@zond/styles/global.scss';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { TooltipProvider } from '@zond/ui';
import { useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import { brandedConfig, setBrandColor, setupDocumentHead, setupWebManifest } from '../utils/branding';
import AuthProvider from './auth-provider';
import i18n from './i18n/config';
import { LanguageProvider } from './i18n/language-provider';
import { router } from './routes';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
});

export function App() {
  useEffect(() => {
    setBrandColor(brandedConfig.primaryColor);
    setupWebManifest();
  }, []);

  return (
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <I18nextProvider i18n={i18n}>
          <LanguageProvider>
            <TooltipProvider>
              <div className="font-geist h-screen flex flex-col">
                <RouterProvider router={router} />
              </div>
            </TooltipProvider>
          </LanguageProvider>
        </I18nextProvider>
      </QueryClientProvider>
    </AuthProvider>
  );
}

export default App;
